import { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  AreaChart,
  Area,
  BarChart,
  Bar,
} from "recharts";
import { Box, createTheme, Stack, Typography, Grid } from "@mui/material";

const OperatingExpensesChart = ({ incomeDetails }) => {
  const [operatingExpensesData, setOperatingExpensesData] = useState();

  useEffect(() => {
    // console.log("income details", incomeDetails);
    if (incomeDetails?.income?.length > 0) {
      let data = incomeDetails?.income?.map((i) => {
        return {
          fiscalPeriod: `FY${i?.fiscalYear - 2000} Q${i?.fiscalQuarter}`,
          operatingExpenses: i?.operatingExpense,
        };
      });
      let temp = [];
      // console.log("d=>", data);

      for (let i = 15; i >= 0; i--) {
        temp?.push(data[i]);
      }

      // console.log("data>", temp);
      setOperatingExpensesData(temp);
    }
  }, [incomeDetails]);
  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        Operating Expenses
      </Box>
      <ResponsiveContainer width="100%" aspect={3}>
        <BarChart
          width={500}
          height={900}
          data={operatingExpensesData}
          
          margin={{
            top: 5,
            right: 5,
            left: 0,
            bottom: 5,
          }}
          barSize={34}
          barCategoryGap={26}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="fiscalPeriod" tick={{ fontSize: 10, color: "" }} />
          <YAxis tick={{ fontSize: 8, color: "" }} />
          <Tooltip />
          <Legend />

          <Bar dataKey="operatingExpenses" fill="#2d79db" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default OperatingExpensesChart;
